import React from 'react';
import { Container } from 'mdbreact';
import { CardGroup, Card, CardBody, CardTitle, CardText } from 'mdbreact';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';

// TODO: Uncomment as soon as we need it!
// // import thumb_jodoin_461678 from 'assets/quotes/zthumb-jodoin-461678.jpg'
// import thumb_quote_1 from 'assets/quotes/zthumb-jodoin-461678.jpg';
// import thumb_quote_2 from 'assets/quotes/zthumb_alain-pham-248563-unsplash.jpg';
// import thumb_quote_3 from 'assets/quotes/zthumb_anders-jilden-219256-unsplash.jpg';
// import thumb_quote_4 from 'assets/quotes/zthumb_ari-spada-562202-unsplash.jpg';
// import thumb_quote_5 from 'assets/quotes/zthumb_changyu-hu-16336-unsplash.jpg';
// import thumb_quote_6 from 'assets/quotes/zthumb_charisse-kenion-492109-unsplash.jpg';
// import thumb_quote_7 from 'assets/quotes/zthumb_chris-abney-123083-unsplash.jpg';
// import thumb_quote_8 from 'assets/quotes/zthumb_chuttersnap-248912-unsplash.jpg';
// import thumb_quote_9 from 'assets/quotes/zthumb_dmitri-popov-173676-unsplash.jpg';
// import thumb_quote_10 from 'assets/quotes/zthumb_dmitri-popov-291898-unsplash.jpg';
// import thumb_quote_11 from 'assets/quotes/zthumb_dmitri-popov-325737-unsplash.jpg';
// import thumb_quote_12 from 'assets/quotes/zthumb_dmitri-popov-92885-unsplash.jpg';
// import thumb_quote_13 from 'assets/quotes/zthumb_drmakete-lab-57353-unsplash.jpg';
// import thumb_quote_14 from 'assets/quotes/zthumb_frances-gunn-57430-unsplash.jpg';
// import thumb_quote_15 from 'assets/quotes/zthumb_francesca-saraco-65449-unsplash.jpg';
// import thumb_quote_16 from 'assets/quotes/zthumb_fre-sonneveld-156775-unsplash.jpg';
// import thumb_quote_17 from 'assets/quotes/zthumb_henry-perks-102400-unsplash.jpg';
// import thumb_quote_18 from 'assets/quotes/zthumb_hugo-sousa-270201-unsplash.jpg';
// import thumb_quote_19 from 'assets/quotes/zthumb_jakub-gorajek-173097-unsplash.jpg';
// import thumb_quote_20 from 'assets/quotes/zthumb_james-padolsey-152010-unsplash.jpg';
// import thumb_quote_21 from 'assets/quotes/zthumb_james-traf-47498-unsplash.jpg';
// import thumb_quote_22 from 'assets/quotes/zthumb_lance-anderson-256077-unsplash.jpg';
// import thumb_quote_23 from 'assets/quotes/zthumb_lobostudio-hamburg-17687-unsplash.jpg';
// import thumb_quote_24 from 'assets/quotes/zthumb_luca-bravo-198062-unsplash.jpg';
// import thumb_quote_25 from 'assets/quotes/zthumb_ng-55633-unsplash.jpg';
// import thumb_quote_26 from 'assets/quotes/zthumb_samuel-zeller-248740-unsplash.jpg';
// import thumb_quote_27 from 'assets/quotes/zthumb_steve-driscoll-106346-unsplash.jpg';
// import thumb_quote_28 from 'assets/quotes/zthumb_viktor-jakovlev-36799-unsplash.jpg';

import thumb_quote_1 from 'assets/quotes/zthumb-jodoin-461678.jpg';
import thumb_quote_2 from 'assets/quotes/zthumb_alain-pham-248563-unsplash.jpg';
import thumb_quote_8 from 'assets/quotes/zthumb_chuttersnap-248912-unsplash.jpg';
import thumb_quote_12 from 'assets/quotes/zthumb_dmitri-popov-92885-unsplash.jpg';
import thumb_quote_18 from 'assets/quotes/zthumb_hugo-sousa-270201-unsplash.jpg';

class PageHome extends React.Component {
  static get propTypes() {
    return {
      propTitle: PropTypes.string,
      onActivated: PropTypes.func
    };
  }

  componentDidMount() {
    console.log(`PageHome::componentDidMount with props: ${this.props}`);
    console.log(this.props);
    this.props.onActivated(this.props.propTitle);
  }

  render() {
    console.log('PageHome::render');
    return (
      <Container className="mt-5">
        <div className="no-margin">
          <h1> Architecture Quotes </h1>

          <CardGroup column>

            <Card className="card-image" style={{ backgroundImage: `url(${thumb_quote_1})` }}>
              <div className="text-white text-center d-flex align-items-center rgba-indigo-strong py-5 px-4">
                <div>
                  <p>We need houses as we need clothes, architecture stimulates fashion. It’s like hunger and thirst — you need them both.</p>
                  <h5 className="orange-text text-right"> Karl Lagerfeld </h5>
                </div>
              </div>
            </Card>

            <Card>
              <CardBody>
                <CardTitle tag="h5">I call architecture frozen music.</CardTitle>
                <CardText className="text-right">Johann Wolfgang von Goethe</CardText>
              </CardBody>
            </Card>

            <Card>
              <CardBody>
                <CardTitle tag="h6">98% of what gets built today is shit.</CardTitle>
                <CardText className="text-right">Frank Gehry</CardText>
              </CardBody>
            </Card>

            <Card className="card-image" style= {{ backgroundImage: `url(${thumb_quote_2})` }}>
              <div className="text-white text-center d-flex align-items-center rgba-blue-strong py-5 px-4">
                <div>
                  {/* eslint-disable-next-line max-len */}
                  <p> Architecture is always the will of the age conceived as space - nothing else. Until this simple truth is clearly recognized, the struggle over the foundation of a new architecture confident in its aims and powerful in its impact cannot be realized; until then, it is destined to remain a chaos of uncoordinated forces.</p>
                  <h5 className="yellow-text text-right"> Ludwig Mies Van Der Rohe </h5>
                </div>
              </div>
            </Card>

            <Card>
              <CardBody>
                <CardTitle tag="h5">We shape our buildings, thereafter they shape us.</CardTitle>
                <CardText className="text-right">Winston Churchill</CardText>
              </CardBody>
            </Card>

            <Card>
              <CardBody>
                <CardTitle tag="h5">Less is more.</CardTitle>
                <CardText className="text-right">Ludwig Mies Van Der Rohe</CardText>
              </CardBody>
            </Card>

            <Card color="primary-color" text="white" className="text-center p-3">
              <blockquote className="blockquote mb-0">
                {/* eslint-disable-next-line max-len */}
                <p>Architecture is really about well-being. I think that people want to feel good in a space… On the one hand it’s about shelter, but it’s also about pleasure.</p>
                <h5 className="yellow-text text-right"> Zaha Hadid </h5>
              </blockquote>
            </Card>

            <Card>
              <CardBody>
                <CardTitle tag="h5">Simplicity is the ultimate sophistication.</CardTitle>
                <CardText className="text-right">Leonardo da Vinci</CardText>
              </CardBody>
            </Card>

            <Card>
              <CardBody>
                <CardTitle tag="h5">Form ever follows function.</CardTitle>
                <CardText className="text-right">Louis Sullivan</CardText>
              </CardBody>
            </Card>

            <Card className="card-image" style={{ backgroundImage: `url(${thumb_quote_8})` }}>
              <div className="text-white text-center d-flex align-items-center rgba-blue-strong py-5 px-4">
                <div>
                  <p> The mother art is architecture. Without an architecture of our own we have no soul of our own civilization.</p>
                  <h5 className="yellow-text text-right"> Frank Lloyd Wright </h5>
                </div>
              </div>
            </Card>

            <Card color="secondary-color" text="white" className="text-center p-3">
              <blockquote className="blockquote mb-0">
                <p>As an architect you design for the present, with an awareness of the past, for a future which is essentially unknown.</p>
                <h5 className="orange-text text-right"> Norman Foster </h5>
              </blockquote>
            </Card>

            <Card className="card-image" style={{ backgroundImage: `url(${thumb_quote_12})` }}>
              <div className="text-white text-center d-flex align-items-center  py-5 px-4">
                <div>
                  {/* eslint-disable-next-line max-len */}
                  <p> When I’m working on a problem, I never think about beauty. But when I’ve finished, if the solution is not beautiful I know it’s wrong.</p>
                  <h5 className="black-text text-right"> Buckminster Fuller </h5>
                </div>
              </div>
            </Card>

            <Card color=" blue-grey lighten-5" text="magenta" className="text-center p-3">
              <blockquote className="blockquote mb-0 card-body">
                <p>Architecture is the learned game, correct and magnificent, of forms assembled in the light.</p>
                <h5 className="indigo-text text-right"> Le Corbusier </h5>
              </blockquote>
            </Card>

            <Card className="card-image" style={{ backgroundImage: `url(${thumb_quote_18})` }}>
              <div className="text-white text-center d-flex align-items-center rgba-grey-strong py-5 px-4">
                <div>
                  {/* eslint-disable-next-line max-len */}
                  <p>The architect represents neither a Dionysian nor an Apollinian condition: here it is the mighty act of will, the will which moves mountains, the intoxication of the strong will, which demands artistic expression. The most powerful men have always inspired the architects; the architect has always been influenced by power.</p>
                  <h5 className="teal-text text-right"> Friedrich Nietzsche </h5>
                </div>
              </div>
            </Card>

            <Card>
              <CardBody>
                <CardTitle tag="h5">Less is bore.</CardTitle>
                <CardText className="text-right">Robert Venturi</CardText>
              </CardBody>
            </Card>

          </CardGroup>

        </div>
      </Container>

    );
  }
}

export default withRouter(PageHome);




// WEBPACK FOOTER //
// ./src/Pages/Home/page-home.js